import React from 'react';
import { Link } from 'react-router-dom';
import RouterUtils from '../../../../routing/RouterUtils';
import { PsRoutes } from '../../../../routing/Routes';
import './BrandLink.css';

export const BrandLink = () => {
    return (
        <Link className="ps-topbar-brand" to={RouterUtils.generateRoute(PsRoutes.HOME)}>
            Portalsub
        </Link>
    );
};

BrandLink.propTypes = {};

BrandLink.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/topbar/brand-link/BrandLink.jsx